<template>
  <v-layout class="mt-4">
    <v-layout v-for="area in areas" :key="area.label" align-center justify-center column>
      <h3>{{ area.label }}</h3>
      <v-progress-circular
        :rotate="360"
        :size="100"
        :width="15"
        :value="area.value"
        :color="area.color"
      >{{ area.value }}</v-progress-circular>
    </v-layout>
  </v-layout>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import treeHelper from "@/helpers/treeHelper";
import cms from "@/content";

export default {
  created() {
    this.getSurgeries(this.user.license).then(() => {});
  },
  methods: {
    ...mapActions(["setSurgeries", "getSurgeries"])
  },
  computed: {
    ...mapGetters(["surgeries", "user"]),
    type50() {
      return this.surgeries.filter(
        s => (s.treeValues && s.treeValues.includes(50)) || []
      );
    },
    type51() {
      return this.surgeries.filter(
        s => (s.treeValues && s.treeValues.includes(51)) || []
      );
    },
    type53() {
      return this.surgeries.filter(
        s => (s.treeValues && s.treeValues.includes(53)) || []
      );
    },
    areas() {
      return [
        {
          label: treeHelper.getNode(cms.getTree(), 50).text,
          value:
            Math.round(
              (this.type50.length / (this.surgeries.length || 1)) * 100
            ) + "%",
          color: "red"
        },
        {
          label: treeHelper.getNode(cms.getTree(), 51).text,
          value:
            Math.round(
              (this.type51.length / (this.surgeries.length || 1)) * 100
            ) + "%",
          color: "yellow"
        },
        {
          label: treeHelper.getNode(cms.getTree(), 53).text,
          value:
            Math.round(
              (this.type53.length / (this.surgeries.length || 1)) * 100
            ) + "%",
          color: "teal"
        }
      ];
    }
  }
};
</script>